module.exports = __webpack_public_path__ + "img/Pic_WGM_LB_c.85aa6d68.gif";